import React, { useState, useEffect, MouseEvent, ChangeEvent } from 'react';
import { findCountryNameById } from '@helpers/countries';
import { Select } from '@components/Select';
import { SimpleSelect } from '@components/SimpleSelect';
import {
  getItemFromList,
  getFiltersFromURL,
  getItemFromSubList,
  setURLfromFilters,
  findOfficeNameById,
} from './ContactUsFilter.helpers';
import './ContactUsFilter.scss';
import { Button } from '@components/Button';
import {
  useFetchContactUsFormQuery,
  useLazyFetchFindOfficeDataQuery,
} from '@pages/ContactUs/ContactUs.service';
import { CountryItem, SublistItem } from '@type/common';
import { Input } from '@components/Input';

const ContactUsFilter = () => {
  const initialFilters = getFiltersFromURL();
  const [filters, setFilters] = useState({
    countryId: initialFilters.countryId || window.countryId,
    officeTypeId: initialFilters.officeTypeId || '0',
    zipcode: initialFilters.zipcode || '',
    isFilter: false,
  });

  const { data: contactUsForm } = useFetchContactUsFormQuery();
  const [fetchFindOfficeData, { data: findOfficeData }] = useLazyFetchFindOfficeDataQuery();
  const [selectedOffice, setSelectedOffice] = useState<SublistItem>(null);
  const [selectedCountry, setSelectedCountry] = useState<CountryItem>(null);

  const i18n = contactUsForm?.I18;

  useEffect(() => {
    fetchFindOfficeData({
      countryId: +filters.countryId,
      officeTypeId: +filters.officeTypeId,
    }).then(({ data: findOfficeData }) => {
      setSelectedCountry(
        getItemFromSubList(filters.countryId, findOfficeData.Regions, 'Countries')
      );
      setSelectedOffice(
        getItemFromList(filters.officeTypeId.toString(), findOfficeData.Officetype)
      );
    });
  }, []);

  const selectOffice = (officeType: SublistItem) => {
    const selectedOffId = officeType?.Id ?? 0;
    setSelectedOffice(officeType);
    setFilters({
      ...filters,
      officeTypeId: selectedOffId.toString(),
    });

    fetchFindOfficeData({
      countryId: +filters.countryId,
      officeTypeId: +selectedOffId,
    });
  };

  const selectZipcode = (code: { Name: string }) => {
    setFilters({ ...filters, zipcode: code.Name });
  };

  const selectCountry = (country) => {
    const countryId = country ? country.Id : window.countryId;
    setSelectedCountry(country);
    setFilters({ ...filters, countryId, zipcode: '' });

    fetchFindOfficeData({
      countryId: +countryId,
      officeTypeId: +filters.officeTypeId,
    });
  };

  const doSetUrlFromFilters = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const selectedCountryName =
      selectedCountry?.Name || (filters.countryId === '0' && i18n.International) || '';
    const selectedOfficeName =
      selectedOffice?.Name || (filters.officeTypeId === '0' && i18n.All) || '';

    const updatedFilters = {
      ...filters,
      isFilter: true,
      zipcode: filters.zipcode === '' ? null : filters.zipcode,
    };

    setFilters(updatedFilters);
    setURLfromFilters({
      ...updatedFilters,
      countryName: selectedCountryName,
      officeName: selectedOfficeName,
    });
    localStorage.setItem('OffBtnClicked', 'true');
  };

  // TODO: make select as lang specific
  return i18n && findOfficeData ? (
    <div className='c-contact-block'>
      <Select
        label={i18n.ChooseCountry}
        title={findCountryNameById(filters.countryId, findOfficeData.Regions, i18n.International)}
        defaultTitle={i18n.International}
        selectableTitle={true}
        list={findOfficeData.Regions}
        name='Name'
        sub='Countries'
        selectFunction={selectCountry}
        backLabel={i18n.Back}
      />

      <SimpleSelect
        label={i18n.TypeOfContact}
        title={findOfficeNameById(
          filters.officeTypeId,
          findOfficeData.Officetype,
          i18n.All,
          'Select'
        )}
        list={[
          {
            Id: '0',
            Name: i18n.All,
          },
          ...findOfficeData.Officetype,
        ]}
        name='Name'
        selectFunction={selectOffice}
      />

      {/* select zip code from pre-defined values if there are such values
          type manually if there are no such values */}
      {findOfficeData.ZipCodes && findOfficeData.ZipCodes.length > 0 ? (
        <SimpleSelect
          label={i18n.Zipcode}
          title={filters.zipcode}
          list={findOfficeData.ZipCodes}
          name='Name'
          selectFunction={selectZipcode}
        />
      ) : (
        <Input
          label={i18n.Zipcode}
          type='text'
          name='zipcode'
          defaultValue={filters.zipcode}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setFilters({ ...filters, zipcode: e.target.value })
          }
        />
      )}

      <Button
        onClick={doSetUrlFromFilters}
        color='primary'
        size='small'
        text={i18n.FindYourContact}
      />
    </div>
  ) : null;
};

export default ContactUsFilter;
